<form [formGroup]="form">
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <input matInput type="number" min="1" formControlName="value" (blur)="touched()" />

    <mat-select matSuffix formControlName="unit" (closed)="touched()" class="suffix-select">
      @for (unit of units(); track $index) {
        <mat-option [value]="unit">{{ unit }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>
